import { useMemo } from 'react';
import { useFreshdeskContextState } from 'store';
import buildPermissionFlags from './permission-flags';

const buildFormBuilderPermission = ({ hasReadPermission, hasCreatePermission, hasUpdatePermission, hasDeletePermission }) => ({
  view: hasReadPermission,
  create: hasCreatePermission,
  edit: hasUpdatePermission,
  delete: hasDeletePermission,
});

const useSchemaPermissions = () => {
  const { getSchemaPermissions } = useFreshdeskContextState();

  return useMemo(() => {
    const permissionFlags = buildPermissionFlags(getSchemaPermissions());
    return {
      ...permissionFlags,
      formBuilderPermission: buildFormBuilderPermission(permissionFlags),
    };
  }, [getSchemaPermissions]);
};

export default useSchemaPermissions;
